export class AntifraudeDataModel {
    name: string;
    value: number;
    dateTransaction: string;
    showAntifraude: boolean;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-response/models/antifraude-data.model.ts